"use strict";

var abiDecodeData = require("./abi-decode-data");

function abiDecodeRpcResponse(responseType, abiEncodedRpcResponse) {
  var decodedRpcResponse = abiDecodeData([{type: responseType}], abiEncodedRpcResponse)[0];
  if (responseType === "bool") return Boolean(decodedRpcResponse);
  return decodedRpcResponse;
}

module.exports = abiDecodeRpcResponse;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/abi-decode-rpc-response.js
// module id = 1326
// module chunks = 157